import service from "../api/monitor.service";
//constants
const data = {
  monitorData: [],
  payments: [],
  responseMonitor: null,
  noPermittedMonitor: "",
  totalRows: 0,
  sendPayment: [],
  amount: { total: 0, coin: null },
};

//types
const PAYMENT_MONITOR = "PAYMENT_MONITOR";
const LIST_MONITOR = "LIST_MONITOR";
const LIST_MONITOR_ERROR = "LIST_MONITOR_ERROR";
const COUNT_MONITOR = "COUNT_MONITOR";
const SEND_PAYMENT = "SEND_PAYMENT";
const TOTAL_PAYMENT = "TOTAL_PAYMENT";
const CLEAN_PAYMENT = "CLEAN_PAYMENT";

//reducer
export default function monitorReducer(state = data, action) {
  switch (action.type) {
    case LIST_MONITOR:
      return { ...state, monitorData: action.payload };
    case LIST_MONITOR_ERROR:
      return { ...state, noPermittedMonitor: action.payload };
    case COUNT_MONITOR:
      return { ...state, totalRows: action.payload };
    case SEND_PAYMENT:
      return { ...state, sendPayment: action.payload };
    case TOTAL_PAYMENT:
      return { ...state, amount: action.payload };
    case CLEAN_PAYMENT:
      return { ...state, amount: { total: 0, coin: null } };
    case PAYMENT_MONITOR:
      return {
        ...state,
        payments: action.payload,
        amount: { total: 0, coin: null },
        totalRows: 0,
        monitorData: []
      };
    default:
      return { ...state };
  }
}
export const getPayments = (json, username) => async (dispatch) => {

  json.dateStart = getDateFormat(json.dateStart);
  json.dateEnd = getDateFormat(json.dateEnd);

  let response = await service.getAllDataMonitorExport(json, username).then((r) => {
    return r.data !== undefined ? r.data : r.response.data;
  });

  if (response.code !== undefined) {
    dispatch({
      type: LIST_MONITOR_ERROR,
      payload: response,
    });
    dispatch({
      type: PAYMENT_MONITOR,
      payload: [],
    });
  } else {
    dispatch({
      type: LIST_MONITOR_ERROR,
      payload: "",
    });
    let data = [];
    response.forEach(element => {

        let obj = {
          BANCO: element.bankName,
          CANAL: element.channelName,
          'COD. DEUDOR': element.clientCodeSap,
          'CLIENTE': element.clientName,
          'FECHA': new Date(element.operationOnlyDate).toLocaleDateString(
            'es-ES',
            { year: 'numeric', month: 'numeric', day: 'numeric' }
          ),
          'FACTURA BOLIVIA': element.numberBill,
          'MONTO': element.operationAmount,
          'MONEDA': element.code,
          'COD. SAP DOCUMENTO': element.numberDocumentSap,
        };
        data.push(obj);

    });
    dispatch({
      type: PAYMENT_MONITOR,
      payload: data,
    });
  }
};

export const findData = (json, username) => async (dispatch) => {

  json.dateStart = getDateFormat(json.dateStart);
  json.dateEnd = getDateFormat(json.dateEnd);

  let response = await service.findDataMonitor(json, username).then((r) => {
    return r.data !== undefined ? r.data : r.response.data;
  });

  if (response.code !== undefined) {
    dispatch({
      type: LIST_MONITOR_ERROR,
      payload: response,
    });
    dispatch({
      type: LIST_MONITOR,
      payload: [],
    });
  } else {
    dispatch({
      type: LIST_MONITOR_ERROR,
      payload: "",
    });
    dispatch({
      type: LIST_MONITOR,
      payload: response,
    });
  }
};
const getDateFormat = (dateStart) => {
  const startMonth = dateStart.getMonth() + 1 + "";
  const startDay = dateStart.getDate() + "";
  const startDate =
    dateStart.getFullYear() +
    "-" +
    startMonth.padStart(2, "0") +
    "-" +
    startDay.padStart(2, "0");

  return startDate;
};
export const getCountData = (json, username) => async (dispatch) => {
  json.dateStart = getDateFormat(json.dateStart);
  json.dateEnd = getDateFormat(json.dateEnd);

  let response = await service.countDataMonitor(json, username).then((r) => {
    return r.data !== undefined ? r.data : r.response.data;
  });
  if (response.code !== undefined) {
    dispatch({
      type: LIST_MONITOR_ERROR,
      payload: response,
    });
    dispatch({
      type: COUNT_MONITOR,
      payload: 0,
    });
  } else {
    dispatch({
      type: LIST_MONITOR_ERROR,
      payload: "",
    });
    dispatch({
      type: COUNT_MONITOR,
      payload: response,
    });
  }
};
export const getTotal = (json) => async (dispatch) => {

  json.dateStart = getDateFormat(json.dateStart);
  json.dateEnd = getDateFormat(json.dateEnd);

  let response = await service.getTotal(json).then((r) => {
    return r.data !== undefined ? r.data : r.response.data;
  });
  if (response.code !== undefined) {
    dispatch({
      type: LIST_MONITOR_ERROR,
      payload: response,
    });
    dispatch({
      type: TOTAL_PAYMENT,
      payload: { total: 0, coin: null },
    });
  } else {
    dispatch({
      type: LIST_MONITOR_ERROR,
      payload: "",
    });
    dispatch({
      type: TOTAL_PAYMENT,
      payload: response,
    });
  }
};
export const clean = () => async (dispatch) => {
  dispatch({
    type: CLEAN_PAYMENT,
    payload: { total: 0, coin: null },
  });
}
export const sendPayment = (lsData) => async (dispatch) => {
  const response = await service.sendPayment(lsData).then((r) => {
    return r;
  });
  dispatch({
    type: SEND_PAYMENT,
    payload: response,
  });
  return response;
};
